import { getApiError } from 'utils/helpers'

import { useGetLettersQuery, useDeleteLetterMutation } from './api'

const POLLING_INTERVAL = 30_000

export function useGetAllLettersRequest(page: number, limit: number, pollingInterval = POLLING_INTERVAL) {
  const request = useGetLettersQuery(
    { page, limit },
    {
      pollingInterval,
    },
  )

  return { ...request, error: getApiError(request.error) }
}

export function useDeleteLetterRequest() {
  const [deleteLetter, request] = useDeleteLetterMutation()

  const onDeleteLetter = async (id: string) => {
    return deleteLetter({ id }).unwrap()
  }

  return { onDeleteLetter, ...request, error: getApiError(request.error) }
}
